import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, CanActivate, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from './services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  
  constructor(private authservice : AuthService, private router:Router) { }
  canActivate(route: ActivatedRouteSnapshot): boolean {
    //logic to check if user is logged in
    if(this.authservice.authenticated){
      return this.authservice.isLoggedIn;
    }
    this.router.navigate(['login']);
    return false;
  
  }
  
}
